import { GlossaryTextSerializer } from './GlossaryTextSerializer';
import { TextHelper } from '../../helpers/TextHelper';

class FAQSerializer {
  static deSerialize(data) {
    const faqs = [];
    data.forEach((question) => {
      let faqCategory = faqs.find(faq => faq.id === String(question.FAQsTipo.FTiId));
      if (!faqCategory) {
        const dataFAQCategory = question.FAQsTipo;
        faqCategory = {
          id: String(dataFAQCategory.FTiId),
          name: dataFAQCategory.FTiNombre,
          questions: [],
        };
        faqs.push(faqCategory);
      }
      faqCategory.questions.push({
        question: question.FaqPregunta,
        answer: TextHelper.separateIntoParagraphs(question.FaqRespuesta)
          .map(GlossaryTextSerializer.deSerialize),
      });
    });
    return faqs;
  }
}

export { FAQSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/FAQSerializer.js